import { useEffect, useState } from "react";
import VAcctModal from "../components/modals/VAcctModal";
import axios from "axios";
import { IoSearchOutline } from "react-icons/io5";
import Pagination from "../components/Pagination";
import { FaPhone, FaWhatsapp } from "react-icons/fa6";
import { FaSpinner } from "react-icons/fa";

export const VirtualAccount = () => {
  const [allAccounts, setAllAccounts] = useState<any[]>([]);
  const [vAcct, setVAcct] = useState({});
  const [showVAcct, setShowVAcct] = useState(false);
  const [searchedUser, setSearchedUser] = useState<any>([]);
  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const [itemsPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastPost = currentPage * itemsPerPage;
  const indexOfFirstPost = indexOfLastPost - itemsPerPage;
  const currentItems = allAccounts.slice(indexOfFirstPost, indexOfLastPost);

  // Pagination
  const handlePagination = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const prevPage = () => {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = () => {
    if (currentPage !== Math.ceil(allAccounts.length / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  useEffect(() => {
    const fetchAcct = async () => {
      setIsLoading(true);
      try {
        const auth: any = sessionStorage.getItem("authState");
        const jsonData = auth ? JSON.parse(auth) : {};
        const token = jsonData?.token;

        if (!token) {
          console.error("Authentication token not found");
          setAllAccounts([]);
          setIsLoading(false);
          return;
        }

        console.log("Using token for API request:", token);

        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/getStateGovernmentAllVirtualAccountDetails`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (
          res.data &&
          res.data.customers &&
          Array.isArray(res.data.customers)
        ) {
          console.log("Setting accounts:", res.data.customers);
          if (res.data.customers.length > 0) {
            setAllAccounts(res.data.customers);
          } else {
            console.log("API returned empty customers array");
            setAllAccounts([]);
          }
        } else if (res.data && Array.isArray(res.data)) {
          console.log("API returned array directly:", res.data);
          setAllAccounts(res.data);
        } else if (res.data && typeof res.data === "object") {
          const possibleCustomers = Object.values(res.data).find((val) =>
            Array.isArray(val)
          );
          if (possibleCustomers) {
            console.log(
              "Found customers in different property:",
              possibleCustomers
            );
            setAllAccounts(possibleCustomers as []);
          } else {
            console.error(
              "Could not find customers array in response:",
              res.data
            );
            setAllAccounts([]);
          }
        } else {
          console.error("Invalid response format:", res.data);
          setAllAccounts([]);
        }
      } catch (error) {
        console.error("API Error:", error);
        setAllAccounts([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchAcct();
  }, []);

  const handleViewAcct = (acctData: object, item: any) => {
    const enrichedAcctData = {
      ...acctData,
      ministry: item.ministry,
      category: item.category,
    };
    setVAcct(enrichedAcctData);
    setShowVAcct((prev) => !prev);
  };

  const searchForUsersWithEmail = (value: string) => {
    setSearchedUser(value);
    if (value.length > 0) {
      const searchResult =
        allAccounts?.filter((user: any) =>
          user.email?.toLowerCase().includes(value.toLowerCase())
        ) || null;
      setSearchResults(searchResult);
    } else {
      setSearchResults([]);
    }
  };

  return (
    <main className="w-full">
      <div className="bg-white p-3 rounded-md mb-3 flex items-center justify-between">
        <h1 className="font-bold text-lg">Virtual Account</h1>
        <div className="relative md:w-[30rem] w-fit">
          <IoSearchOutline className="w-6 h-6 absolute top-[0.6rem] left-2 text-gray-300" />
          <input
            type="search"
            name="searchedUser"
            id="searchedUser"
            value={searchedUser}
            onChange={(e) => searchForUsersWithEmail(e.target.value)}
            placeholder="Search user using email"
            className="border p-2 rounded-md indent-7 w-full"
            disabled={allAccounts.length === 0}
          />
        </div>
      </div>
      <section>
        <table className="w-full text-left">
          <thead className="bg-gray-50 h-12 rounded-md">
            <tr>
              <th className="px-2">SN</th>
              <th className="px-2">Name</th>
              <th className="px-2">Email</th>
              <th className="px-2">Phone Number</th>
              <th className="px-2">Ministry</th>
              <th className="px-2">Category</th>
              <th className="px-2">Contact</th>
              <th className="px-2">Account</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={10} className="text-center p-10">
                  <div className="flex justify-center items-center">
                    <FaSpinner className="animate-spin text-secondary mr-2 text-xl" />
                    <span>Loading virtual accounts...</span>
                  </div>
                </td>
              </tr>
            ) : allAccounts.length === 0 ? (
              <tr>
                <td colSpan={10} className="text-center text-secondary p-3">
                  No virtual accounts available
                </td>
              </tr>
            ) : searchedUser.length > 0 ? (
              searchResults && searchResults.length > 0 ? (
                searchResults.map((item: any, index) => (
                  <tr key={index} className="border-b">
                    <td className="p-2">{index + 1}</td>
                    <td className="p-2">
                      {item.lastName + " " + item.firstName}
                    </td>
                    <td className="p-2">{item.email}</td>
                    <td className="p-2">{item.phoneNumber}</td>
                    <td className="p-2">{item.ministry || "N/A"}</td>
                    <td className="p-2">{item.category || "N/A"}</td>
                    <td className="p-2 text-nowrap flex justify-evenly">
                      <button type="button" title="call customer">
                        <a href={`tel:${item?.phoneNumber}`}>
                          <FaPhone />
                        </a>
                      </button>
                      <button type="button" title="text via whatsapp">
                        <a
                          href={`https://wa.me/${item?.phoneNumber?.replace(
                            /^0/,
                            "234"
                          )}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FaWhatsapp />
                        </a>
                      </button>
                    </td>

                    <td className="p-2">
                      <button
                        type="button"
                        onClick={() =>
                          handleViewAcct(item.virtualAccount, item)
                        }
                        className="bg-secondary text-sm text-white p-2 rounded-md hover:bg-green-700"
                      >
                        View Account
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={10} className="text-center text-secondary p-3">
                    User with email not found
                  </td>
                </tr>
              )
            ) : currentItems.length > 0 ? (
              currentItems.map((item: any, index) => (
                <tr key={index} className="border-b">
                  <td className="p-2">{index + indexOfFirstPost + 1}</td>
                  <td className="p-2">
                    {item.lastName + " " + item.firstName}
                  </td>
                  <td className="p-2">{item.email}</td>
                  <td className="p-2">{item.phoneNumber}</td>
                  <td className="p-2">{item.ministry || "N/A"}</td>
                  <td className="p-2">{item.category || "N/A"}</td>
                  <td className="p-2 text-nowrap flex justify-evenly">
                    <button type="button" title="call customer">
                      <a href={`tel:${item?.phoneNumber}`}>
                        <FaPhone />
                      </a>
                    </button>
                    <button type="button" title="text via whatsapp">
                      <a
                        href={`https://wa.me/${item?.phoneNumber?.replace(
                          /^0/,
                          "234"
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaWhatsapp />
                      </a>
                    </button>
                  </td>

                  <td className="p-2">
                    <button
                      type="button"
                      onClick={() => handleViewAcct(item.virtualAccount, item)}
                      className="bg-secondary text-sm text-white p-2 rounded-md hover:bg-green-700"
                    >
                      View Account
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={10} className="text-center text-secondary p-3">
                  No virtual accounts available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </section>
      <section className="p-3 my-5">
        <Pagination
          length={
            searchResults.length > 0 ? searchResults.length : allAccounts.length
          }
          itemsPerPage={itemsPerPage}
          handlePagination={handlePagination}
          currentPage={currentPage}
          prevPage={prevPage}
          nextPage={nextPage}
        />
      </section>

      {showVAcct && <VAcctModal setShowVAcct={setShowVAcct} acctData={vAcct} />}
    </main>
  );
};
